import type { DebounceSettings } from 'lodash';
import { debounce } from 'lodash';
import { useEffect, useMemo } from 'react';

type Function = (...args: any[]) => void | Promise<void>;

export function useDebounce(wait: number, options?: DebounceSettings) {
    const debouncedFunc = useMemo(() => {
        return debounce((func: Function, ...args: any[]) => func(...args), wait, options);
    }, []);

    useEffect(() => {
        return () => {
            debouncedFunc.cancel();
        };
    }, []);

    return debouncedFunc;
}
